module.exports = __webpack_public_path__ + "img/icon-statements.c412077d.png";